export default {
  "AgreementModal.CloseButton": "Close",
}
